import { Request, HttpResponse } from "./request"
import { BookingModel } from "@/app/models/booking.model"

export interface CreatedBookingDto {
  referenceId: string
  plate: string
  callbackUrl: string
  facilityId: number
}

const request = Request("/provider/booking")

export async function createBooking(
  data: CreatedBookingDto,
): Promise<HttpResponse<BookingModel>> {
  return request()
    .method("POST")
    .data(data)
    .returns(BookingModel)
    .fire()
}

// Internal webview
export async function findOneBooking(
  referenceId: string,
): Promise<HttpResponse<BookingModel>> {
  return request()
    .method("GET")
    .url(`/webview/${referenceId}`)
    .returns(BookingModel)
    .fire()
}

export async function cancelBooking(id: string): Promise<HttpResponse<void>> {
  return request()
    .method("POST")
    .url(`/webview/${id}/cancel`)
    .fire()
}

export async function startBooking(
  referenceId: string,
): Promise<HttpResponse<BookingModel>> {
  return request()
    .method("POST")
    .url(`/webview/${referenceId}/start`)
    .returns(BookingModel)
    .fire()
}

export async function reserveBooking(
  id: string,
): Promise<HttpResponse<BookingModel>> {
  return request()
    .method("POST")
    .url(`/webview/${id}/reserve`)
    .returns(BookingModel)
    .fire()
}

export async function stopBooking(
  referenceId: string,
): Promise<HttpResponse<BookingModel>> {
  return request()
    .method("POST")
    .url(`/webview/${referenceId}/stop`)
    .returns(BookingModel)
    .fire()
}
